import styled from '@emotion/styled';
import { sizeProp } from 'helpers/style';

export const Container = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-around;
    flex-direction: column;
    ${sizeProp};
`;

export const Stripe = styled.div`
    width: 100%;
    ${({ slim }) => (slim ? 'height: 1px' : 'height:3px')};
    border-radius: 1px;
    background-color: ${({ theme: { color } }) => color.white};
`;
